<template>
  <div>
    <el-menu :default-active="$route.path" class="el-menu-demo" router mode="horizontal" background-color="#FFF"
      active-text-color="#1a1a1a" text-color="#1a1a1a">
      <div class="headImg"><img src="../../assets/img/log.jpg" alt="" /></div>
      <el-menu-item index="/homes" class="titfir">{{
        $t("navbar.HOME")
      }}</el-menu-item>
      <el-submenu index="1" class="titfir">
        <template slot="title">{{ $t("navbar.BOOKS") }}</template>
        <div class="titsco">
          <el-menu-item index="/chineseItem?type=1">{{
            $t("navbar.Academic")
          }}</el-menu-item>
          <el-menu-item index="/chineseItem?type=2">{{
            $t("navbar.Literary")
          }}</el-menu-item>
          <el-menu-item index="/chineseItem?type=3">{{
            $t("navbar.Translated")
          }}</el-menu-item>
        </div>
      </el-submenu>
      <el-submenu index="2" class="titfir">
        <template slot="title">{{ $t("navbar.ABOUT") }}</template>
        <div class="titsco">
          <el-menu-item index="/aboutus">{{
            $t("navbar.ABOUTUS")
          }}</el-menu-item>
          <el-menu-item index="/newsItem">{{ $t("navbar.NEWS") }}</el-menu-item>
        </div>
      </el-submenu>
      <el-menu-item index="/contactItem" class="titfir">{{
        $t("navbar.CONTACT")
      }}</el-menu-item>
      <div class="langage" v-if="viewWidth >= 554">
        <span @click="toggleLang('zh')"> 简体中文</span>|<span @click="toggleLang('en')">English</span>
      </div>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: "0",
      viewWidth: window.innerWidth
    };
  },
  watch: {},
  methods: {
    fun(val) {
      this.$router.push(val);
    },
    //切换方法
    toggleLang(lang) {
      this.$i18n.locale = lang;
    }
  }
};
</script>

<style lang="scss" scoped>
.pulish {
  font-size: 0.4rem !important;
}

.headImg {
  img {
    height: 1.8rem;
    width: 5rem;
  }
}

.langage {
  font-size: 0.25rem;
}

.el-menu-demo {
  display: flex;
  justify-content: center;
}

.titfir {
  width: 15%;
  font-size: 0.28rem;
  height: 1.55rem;
  line-height: 1.55rem;
  text-align: center;
}

.el-menu--horizontal>>>.el-submenu .el-submenu__title {
  height: 1.55rem;
  line-height: 1.55rem;
  font-size: 0.28rem;
  text-align: center;
}

.titsco {
  width: 5rem;
}

.el-menu-item {
  text-align: center;
}

.el-menu-demo>>>.is-active {
  font-size: 0.3rem;
  height: 1.55rem;
  line-height: 1.55rem;
  font-weight: 700;
  border: none;
}

.el-submenu>>>.is-active {
  font-size: 0.3rem;
  height: 1.55rem;
  line-height: 1.55rem;
  font-weight: 700;
  border: none;
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 5rem !important;
}

@media screen and (max-width: 854px) {
  .headImg {
    display: contents;

    img {
      height: 1.3rem;
      width: 4rem;
    }
  }

  .el-menu-demo {
    height: 1.3rem;
    line-height: 1.3rem;
    justify-content: flex-start;
  }

  .el-menu--collapse .el-menu .el-submenu,
  .el-menu--popup {
    min-width: 1.3rem !important;
  }

  .titfir>>>.el-submenu__title {
    height: 1.3rem !important;
    line-height: 1.3rem !important;
    background-color: #fff;
    font-size: 0.28rem !important;
  }

  .el-menu--horizontal>>>.el-menu-item {
    height: 1.3rem;
    line-height: 1.3rem;
    font-size: 0.28rem !important;
  }

  .el-menu-demo>>>.is-active {
    height: 1.3rem;
    line-height: 1.3rem;
    font-size: 0.3rem !important;
    font-weight: 700 !important;
  }

  .el-submenu .is-active .is-opened {
    height: 1.3rem;
    line-height: 1.3rem;
    font-size: 0.3rem !important;
    font-weight: 700 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/HeadItem.vue